/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable eqeqeq */

import * as React from "react";
import {Modal} from "react-bootstrap";
import {Alert} from "../ui/form/Alert";


interface State {
    show? : boolean
    error? : string;
    inProgress? : boolean
}
interface Props { id?: string; iconClassName? : string; label? : string; description? : string, onDelete : () => Promise<any> | undefined, onCancel? : () => void, className?:string }
export class DeleteButtonModal extends React.Component<Props,State>{


    constructor(props : Props){
        super(props);
        this.state = {show:false, inProgress : false};
    }

    cancel() {
        this.setState({show : false, error : undefined });
        if(this.props.onCancel) {
            this.props.onCancel();
        }
    }
    doDelete() {
        if(this.state.inProgress == true) {
            return;
        }
        console.log("doDelete before", this.props.onDelete);
        if(this.props.onDelete) {
            this.setState({inProgress: true});
            
            let promise = this.props.onDelete();
            if(promise) {
                promise.then(res=>{
                    this.setState({show : false, error : undefined, inProgress : false});
                }).catch(err => {
                    console.log("reject resolve", err);
                    this.setState({show : true, error : err, inProgress : false});
                });
            }

        }
    }
 
    getDeleteInfo() : any{
        if(this.state.error != null)  {
            return false;
        }
        return <span>You are a about to {this.getLabel()} {this.props.description}</span>
    }
    getDeleteError() : any {
        if(this.state.error == null)  {
            return false;
        }
        let text = "Unable to " + this.getLabel() + this.props.description;
        return <Alert type="danger" text={text} />
    }
    getActions() {
        if(this.state.error != null) {
            return (
                <a  className="btn btn-default" onClick={this.cancel.bind(this)}>Continue</a>
            );
        }
        return (
            <div>
                <button className="btn btn-default" onClick={this.cancel.bind(this)} disabled={this.state.inProgress}>Cancel</button>
                <button className="btn btn-danger" onClick={this.doDelete.bind(this)} disabled={this.state.inProgress}>{this.getLabel()}</button>
            </div>
        );
    }
    getLabel() {
        if(this.props.label) {
            return this.props.label;
        }
        return "Delete";
    }
    render(){
       return [
           
           <a  key={Math.random()} onClick={() => { this.setState({show : true } )}} id={this.props.id ? this.props.id : ""} className={this.props.className}>
               <i className={this.props.iconClassName}></i> {this.getLabel()}
           </a>,
           <Modal key={Math.random()} show={this.state.show} onHide={this.cancel.bind(this)}
                  aria-labelledby="contained-modal-title">
               <Modal.Header  closeButton>
                   <Modal.Title id="contained-modal-title">Are sure you want to {this.getLabel()}?</Modal.Title>
               </Modal.Header>
               <Modal.Body>
                   {this.getDeleteInfo()}
                   {this.getDeleteError()}
               </Modal.Body>
               <Modal.Footer>
                   {this.getActions()}
               </Modal.Footer>
           </Modal>
       ];
    }
}